<!--
 * @FileDescription: 期初库存调整单详情（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
    <div class="page-container">
        <div class="page-container-height">
            <div class="adjustment-title-top">
                <span>单据单号：{{formData.code}}</span>
                <span>单据日期:{{formData.voucherDate}}</span>
            </div>
            <div class="adjustment-title-bottom">
                <div>调出仓库：{{formData.storageName}}</div>
                <div v-if="!isEmpty(formData.transactorName)">经办人：{{formData.transactorName}}</div>
                <div v-if="!isEmpty(formData.digest)">
                    <a-tooltip>
                        <template slot="title">
                         {{formData.digest}}
                        </template>
                        <div class="span-title">
                             摘要：{{formData.digest}}
                        </div>
                    </a-tooltip>
                </div>
                <div v-if="!isEmpty(formData.remark)">
                     <a-tooltip>
                        <template slot="title">
                            {{formData.remark}}
                        </template>
                        <div class="span-title">
                             备注：{{formData.remark}}
                        </div>
                    </a-tooltip>
                </div>
            </div>
            <div class="line"></div>
            <a-table :columns="columns"
                     :dataSource="dataSource"
                     :pagination="false"
                     class="adjustment-table"
                     :scroll="{ y: 'calc(100vh - 420px)' }"
                     bordered>
                <template slot="name" slot-scope="text, record, index">
                    <span class="tab-name"><img src="@/assets/image/manage_zong@2x.png"/>{{ text }}</span>
                </template>
                <template slot="footer">
                    <!--<a-table class="tab-footer table-footer-detail"-->
                             <!--:columns="columns"-->
                             <!--:dataSource="footerDataSource"-->
                             <!--:pagination="false"-->
                             <!--:showHeader="false"-->
                             <!--:bordered="false"-->
                    <!--&gt;</a-table>-->
                    <div class="footer-total-amount">
                        <div class="footer-total-amount-left" style="width: 80px">
                            <span class="title">小计</span>
                        </div>
                        <div class="footer-total-amount-right" v-if="footerDataSource.length>0">
                            <span class="right-col">调整后数量：{{ footerDataSource[0].productCount }}</span>
                            <span class="right-col">调整金额：{{ footerDataSource[0].totalAmount }}</span>
                        </div>
                    </div>
                </template>
            </a-table>
        </div>
    </div>
</template>
<script>
    import {initialItem} from "@/utils/api";
    import {mixins} from "@/mixins/mixins";
    export default {
        mixins:[mixins],
        data(){
            return{
                columns: [
                    {
                        title: '',
                        dataIndex: 'rowIndex',
                        width: 70,
                        align: 'center',
                        customRender: function (text, r, index) {
                            return (text !== '合计') ? (parseInt(index) + 1) : text
                        }
                    },
                    {
                        title: '商品名称',
                        key: 'productName',
                        dataIndex: 'productName',
                        width: 200,
                        scopedSlots: { customRender: 'name' }
                    },
                    {
                        title: '商品编号',
                        ellipsis:true,
                        key: 'productCode',
                        dataIndex: 'productCode',
                    },
                    {
                        title: '规格',
                        ellipsis:true,
                        dataIndex: 'productSpecification',
                        key: 'productSpecification',
                    },
                    {
                        title: '型号',
                        ellipsis:true,
                        key: 'productModel',
                        dataIndex: 'productModel',
                    },
                    {
                        title: '单位',
                        width:70,
                        ellipsis:true,
                        dataIndex:'productUnit',
                        key:'productUnit'
                    },
                    {
                        title: '数量',
                        align: 'right',
                        ellipsis:true,
                        width:100,
                        dataIndex:'productCount',
                        key:'productCount'
                    },
                    {
                        title: '调整后成本价',
                        align: 'right',
                        ellipsis:true,
                        width:120,
                        dataIndex:'costPrice',
                        key:'costPrice'
                    },
                    {
                        title: '调整金额',
                        align: 'right',
                        ellipsis:true,
                        width:120,
                        dataIndex:'totalAmount',
                        key:'totalAmount'
                    },
                    {
                        title: '调整后库位',
                        width:260,
                        ellipsis:true,
                        dataIndex:'locationName',
                        key:'locationName',
                    },
                    {
                        title: '备注',
                        ellipsis:true,
                        dataIndex:'remark',
                        key:'remark'
                    }
                ],
                dataSource: [],
                footerDataSource: [],          // 底部合计
                formData:{
                    storageName:'',
                    code:'',
                    voucherDate:'',
                    transactorName:'',
                    digest:'',
                    remark:''
                },
                detailId:'',
            }
        },
        watch: {

        },
        mounted () {
            this.detailId = this.$route.query.id
            this.getList()
        },
        activated(){

        },
        created () {

        },
        components: {


        },
        methods: {
            /**
             * @description: 表格增加合计行（方法描述）
             */
            tableAddTotalRow (columns, dataSource) {
                let numKey = 'rowIndex'
                let totalRow = { [numKey]: '合计' }
                columns.forEach(column => {
                    let { key, dataIndex } = column
                    if (dataIndex == 'productCount' || dataIndex == 'totalAmount') {
                        let total = 0
                        dataSource.forEach(data => {
                            if(!this.isEmpty(data.productName)){
                                total = total +  Number.parseInt(data[dataIndex])
                            }
                        })
                        totalRow[dataIndex] = total
                    }
                })
                this.footerDataSource.push(totalRow)
            },
            getList(){
                initialItem({},{},{
                    id:this.detailId,
                    companyStoreId:this.$store.state.shopId,
                }).then((res)=>{
                    if(res.success){
                        this.formData.storageName = res.result.storageName
                        this.formData.code = res.result.code
                        this.formData.digest = res.result.digest
                        this.formData.remark = res.result.remark
                        this.formData.transactorName = res.result.transactorName
                        this.formData.voucherDate = res.result.voucherDate
                        this.dataSource = res.result.itemList
                        this.tableAddTotalRow(this.columns, this.dataSource)
                    }
                })
            },
        },

    }
</script>
<style lang="scss">
    .tab-footer{
        .ant-table-row{
            border-top: 2px solid #C6D9F9;
            border-bottom: 2px solid #C6D9F9;
            td{
                border-right:1px solid transparent !important;
            }
        }
        .ant-table-tbody > tr > td:nth-child(1),
        .ant-table-tbody > tr > td:nth-child(7),
        .ant-table-tbody > tr > td:nth-child(9){
            color: #333333;
            font-weight: 700;
        }
    }
    .adjustment-table{
        .ant-table-body{
            max-height: calc(100vh - 420px) !important;
        }
    }
</style>
<style scoped lang="scss">
.page-container-height{
    background-color: #fff;
    .adjustment-title-top{
        padding-top: 30px;
        display: flex;
        justify-content: flex-end;
        span{
            margin-right: 60px;
        }
    }
    .adjustment-title-bottom{
        padding: 30px 0 27px 41px;
        display: flex;
        align-items: center;
        div{
            margin-right: 60px;
            .span-title{
                width: 210px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
            }
        }
    }
    .line{
        height: 14px;
        background-color: #f5f5f5;
    }
    .tab-name{
        width: 220px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        img{
            width: 22px;
            margin-right: 4px;
        }
    }
}
</style>
